import React, { Component } from 'react';
import { getUsers, getAllAdmins } from '../services/userService';
import auth from '../services/authService';
import Spinner from './common/spinner';
import NotFound from './notFound';
import AdminTable from './adminTable';

class Admin extends Component {
  state = {
    users: [],
    loading: false,
  };

  async componentDidMount() {
    this.setState({ loading: true });
    const result = await getAllAdmins();
    this.setState({ loading: false });
    const { data: users } = result.data;
    this.setState({ users });
  }

  getPagedData = () => {
    const { users } = this.state;

    return { data: users };
  };

  render() {
    const { loading } = this.state;
    const { data: users } = this.getPagedData();
    const { isAdmin } = auth.getCurrentUser();
    const filteredUsers = users.filter((user) => user.isAdmin);
    if (loading) return <Spinner message="" />;
    return isAdmin ? (
      <React.Fragment>
        {loading && <Spinner message="" />}
        <AdminTable users={filteredUsers} message="Admin" />
      </React.Fragment>
    ) : (
      <NotFound />
    );
  }
}

export default Admin;
